import React from 'react';

import ResponsiveNetworkFrame from 'semiotic/lib/ResponsiveNetworkFrame';

import { nodes, edges } from './data.js';

import Color from 'color';

import DatGui, {
  DatColor,
  DatNumber,
  DatSelect,
} from '@tim-soft/react-dat-gui';

import './App.css';

const adjustColor = (col, amt) => Color(col).lighten(amt).hex();

export default () => {
  const data = {
    blur: '5',
    distance: '5',
    coreColor: '#ff5a29',
    linkColor: 'white',
    radius: 20,
    size: 10,
    angle: 'ne',
    intensity: 0.4,
    inset: false,
  };

  const [state, setState] = React.useState(data);
  const {
    coreColor,
    radius,
    size,
    intensity,
    linkColor,
    distance,
    blur,
    angle,
  } = state;

  const c1 = adjustColor(coreColor, -1 * intensity);
  const c3 = adjustColor(coreColor, intensity);

  const angles = {
    ne: [1, 1, 1, 1],
    se: [-1, -1, -1, -1],
    sw: [1, -1, 1, -1],
    nw: [-1, 1, -1, 1],
  };

  const [a1, a2, a3, a4] = angles[angle];

  const filter = 'url(#shadow)';

  return (
    <div
      style={{ backgroundColor: coreColor, width: '100vw', height: '100vh' }}
      className="react-dat-gui-demo"
    >
      <DatGui
        className="react-dat-gui-relative-position"
        data={state}
        onUpdate={(prevState, newState) => {
          setState({ ...prevState, ...newState });
        }}
      >
        <DatColor path="coreColor" label="Node color" />
        <DatColor path="linkColor" label="Link color" />

        <DatNumber path="blur" label="Blur" min={0} max={6} step={1} />
        <DatNumber path="distance" label="Distance" min={0} max={5} step={1} />
        <DatNumber path="radius" label="Radius" min={1} max={20} step={1} />
        <DatNumber
          path="intensity"
          label="Intensity"
          min={0.1}
          max={1}
          step={0.1}
        />

        <DatNumber path="size" label="Size" min={1} max={40} step={1} />
        <DatSelect
          label="Angle"
          path="angle"
          options={['ne', 'se', 'sw', 'nw']}
        />
      </DatGui>
      <ResponsiveNetworkFrame
        className="chart"
        responsiveWidth={true}
        responsiveHeight={true}
        baseMarkProps={{
          transitionDuration: { default: 0, fill: 0 },
          r: 1,
          forceUpdate: true,
        }}
        nodes={nodes}
        edges={edges}
        networkType={{
          type: 'force',
          forceManyBody: -250,
          distanceMax: 500,
          edgeStrength: 2,
        }}
        nodeIDAccessor={(e) => e.id}
        nodeStyle={{
          shapeRendering: 'cripEdges',
          fill: coreColor,
          rx: radius,
          ry: radius,
          filter,
        }}
        edgeStyle={{ stroke: linkColor, fill: 'none' }}
        nodeSizeAccessor={size}
        nodeLabels={false}
        additionalDefs={
          <>
            <filter id="shadow" filterUnits="userSpaceOnUse">
              <feDropShadow
                dx={distance * a1}
                dy={distance * a2}
                floodColor={c1}
                stdDeviation={blur}
              />
              <feDropShadow
                dx={-distance * a3}
                dy={-distance * a4}
                stdDeviation={blur}
                floodColor={c3}
              />
            </filter>
          </>
        }
      />
    </div>
  );
};
